export default "__VITE_ASSET__CFMS3t5n__"